import VueInfiniteLoader from "./VueInfiniteLoader";

export default {
    install(Vue, options) {
        Vue.component("VueInfiniteLoader", VueInfiniteLoader);
    }
}